import { Alert, Box } from '@ksyos/design-system';
import type { IPatient } from '@common/interfaces/patient';
import type { PatientHasContractedCareForService } from '@common/interfaces/patientInsurance';
import { getDisplayName } from '@common/utils/getDisplayName';

interface IInsuranceAlertProps {
    onClick: () => void;
    patient: IPatient;
    patientInsurance?: PatientHasContractedCareForService;
}

export function InsuranceAlert(props: IInsuranceAlertProps) {
    const { patientInsurance, onClick, patient } = props;

    if (!patientInsurance) {
        return null;
    }

    let insuranceAlertText;
    if (patientInsurance && patient) {
        if (patientInsurance.hasContractedCare && patientInsurance.isInsured) {
            insuranceAlertText = `${getDisplayName(patient)} ontvangt gecontracteerde zorg`;
        } else if (!patientInsurance.hasContractedCare && patientInsurance.isInsured) {
            insuranceAlertText = `${getDisplayName(patient)} ontvangt ongecontracteerde zorg`;
        } else {
            insuranceAlertText = `${getDisplayName(patient)} is niet verzekerd binnen Nederland`;
        }
    }

    return (
        <Alert appearance="info">
            <Box
                alignItems="flex-start"
                display="flex"
                flexWrap="wrap"
                justifyContent="space-between"
                width="100%"
            >
                <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '675px' }}>
                    <Alert.Text
                        as="p"
                        fontWeight="bold"
                        mb={2}
                        size="md"
                    >
                        {insuranceAlertText}
                    </Alert.Text>
                </div>

                <Alert.Button
                    onClick={() => {
                        onClick();
                    }}
                >
                    Lees informatie over de vergoeding
                </Alert.Button>
            </Box>
        </Alert>
    );
}
